import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, SITE_URL } from "@/content/seo";
import { landingContent, pageFaqLD } from "@/content/landing-content";

const TITLE = "Vilamoura Sunset Cruise · Private Yacht · Morningstar";
const DESC =
  "Private sunset cruise from Vilamoura on the Morningstar yacht — two-hour evening sail with sparkling wine, Portuguese tapas and the Algarve coastline at golden hour.";
const PATH = "/sunset-cruise-vilamoura";
const URL = `${SITE_URL}${PATH}`;
const CONTENT = landingContent.sunsetCruiseVilamoura;

export const Route = createFileRoute("/sunset-cruise-vilamoura")({
  component: () => (
    <SitePage
      lang="en"
      heroOverride={{
        eyebrow: "Sunset Cruise · Vilamoura · Algarve",
        title: "Vilamoura sunset cruise aboard ",
        titleAccent: "Morningstar.",
        sub: "A private evening sail from Marina de Vilamoura toward Olhos d'Água and the Falésia cliffs — sparkling wine, Portuguese tapas and the golden Algarve light.",
        ctaPrimary: "View sunset cruises",
        ctaSecondary: "Plan my sunset",
      }}
      pageContent={CONTENT.en}
    />
  ),
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords:
        "Vilamoura sunset cruise, sunset cruise Vilamoura, sunset boat trip Vilamoura, Algarve sunset cruise, private sunset yacht",
      altPath: { en: PATH, pt: "/pt/cruzeiro-por-do-sol-vilamoura" },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Private Vilamoura Sunset Cruise",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "Vilamoura Sunset Cruise", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(pageFaqLD(CONTENT.en.faqs)) },
      ],
    }),
});